import { FC, ReactNode } from "react";

import styled from "styled-components";

interface SourceMenuItemProps {
  /** Text or node to display. */
  children: ReactNode;
  /** When true, renders with teal colour and bold weight. */
  active: boolean;
}

/**
 * Label component for public data-source menu items.
 *
 * Rendered as the antd Menu `label` ReactNode so active state is carried
 * directly in the DOM — no CSS specificity fights with antd's selection styles.
 */
const SourceMenuItem: FC<SourceMenuItemProps> = ({ children, active }) => (
  <Label $active={active}>{children}</Label>
);

const Label = styled.span<{ $active: boolean }>`
  color: ${({ $active }) => ($active ? "var(--color-primary)" : "inherit")};
  font-weight: ${({ $active }) => ($active ? "600" : "inherit")};
`;

export default SourceMenuItem;
